class BlockKeyFigures {
	constructor() {
		document.querySelectorAll(".block-key-figures").forEach(block => {

			new Swiper(block.querySelector(".swiper"), {
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				speed: 1,
				navigation: {
					prevEl: block.querySelector(".prev"),
					nextEl: block.querySelector(".next"),
				}
			});
		});
	}
}
